/**
 * Maps each FIFA 2026 venue municipality (stadiums.city) to the /cities/:slug guide
 * where sample itineraries and fan copy live.
 */
export const STADIUM_HOST_ENTRIES = [
  { stadiumCity: 'East Rutherford', guideSlug: 'new-york' },
  { stadiumCity: 'Los Angeles', guideSlug: 'los-angeles' },
  { stadiumCity: 'Arlington', guideSlug: 'dallas' },
  { stadiumCity: 'Atlanta', guideSlug: 'atlanta' },
  { stadiumCity: 'Seattle', guideSlug: 'seattle' },
  { stadiumCity: 'Santa Clara', guideSlug: 'san-francisco' },
  { stadiumCity: 'Miami', guideSlug: 'miami' },
  { stadiumCity: 'Houston', guideSlug: 'houston' },
  { stadiumCity: 'Philadelphia', guideSlug: 'philadelphia' },
  { stadiumCity: 'Foxborough', guideSlug: 'boston' },
  { stadiumCity: 'Kansas City', guideSlug: 'kansas-city' },
  { stadiumCity: 'Vancouver', guideSlug: 'vancouver' },
  { stadiumCity: 'Toronto', guideSlug: 'toronto' },
  { stadiumCity: 'Mexico City', guideSlug: 'mexico-city' },
  { stadiumCity: 'Guadalajara', guideSlug: 'guadalajara' },
  { stadiumCity: 'Monterrey', guideSlug: 'monterrey' },
];

/** @param {string} stadiumCity */
export function guideSlugForStadiumCity(stadiumCity) {
  const row = STADIUM_HOST_ENTRIES.find((e) => e.stadiumCity === stadiumCity);
  return row ? row.guideSlug : null;
}
